/* ========================================
   SLIDER INITIALIZATION
   ======================================== */

// Inicializar Splide quando o DOM estiver carregado
document.addEventListener('DOMContentLoaded', function () {
  // Aguardar um pouco para garantir que todos os elementos estejam renderizados
  setTimeout(function () {
    // Inicializar Splide quando o DOM estiver carregado
    const splideElement = document.querySelector('.splide');
    const track = splideElement
      ? splideElement.querySelector('.splide__track')
      : null;
    const list = splideElement
      ? splideElement.querySelector('.splide__list')
      : null;
    const prevButton = splideElement
      ? splideElement.parentElement.parentElement.querySelector(
          '.slider-arrow--prev'
        )
      : null;
    const nextButton = splideElement
      ? splideElement.parentElement.parentElement.querySelector(
          '.slider-arrow--next'
        )
      : null;
    const paginationButtons = splideElement
      ? splideElement.parentElement.parentElement.querySelectorAll(
          '.slider-pagination__button'
        )
      : [];

    // Verificar se todos os elementos necessários existem
    if (splideElement && track && list && list.children.length > 0) {
      window.splideInstance = new Splide(splideElement, {
        type: 'slide', // Mudou de 'loop' para 'slide' - sem clones
        perPage: 1,
        perMove: 1,
        pagination: true, // Habilitado - vamos customizar o CSS
        arrows: false, // Usamos setas customizadas
        autoplay: false,
        interval: 5000,
        pauseOnHover: true,
        resetProgress: false,
        gap: '32px',
        height: 'auto',
        width: '425px',
        breakpoints: {
          992: {
            perPage: 1,
            gap: '12px',
            width: '100%',
          },
        },
      });

      // Conectar botões customizados
      if (prevButton) {
        prevButton.addEventListener('click', () =>
          window.splideInstance.go('<')
        );
      }

      if (nextButton) {
        nextButton.addEventListener('click', () =>
          window.splideInstance.go('>')
        );
      }

      // Conectar paginação customizada
      paginationButtons.forEach((button, index) => {
        button.addEventListener('click', () => window.splideInstance.go(index));
      });

      // Atualizar estado da paginação
      window.splideInstance.on('moved', (newIndex) => {
        paginationButtons.forEach((button, index) => {
          if (index === newIndex) {
            button.classList.add('is-active');
          } else {
            button.classList.remove('is-active');
          }
        });
      });

      window.splideInstance.mount();
    }
  }, 100); // Delay de 100ms
});
